import React, { useEffect, useRef } from 'react';

interface ModalProps {
  host: string;
  isVisible: boolean;
  setModalState: (val: boolean) => void;
}

function Modal({ host, isVisible, setModalState }: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const currPart = host === 'docs.nhn-commerce.com' ? 'server' : '(모듈)';

  const handlerClickEl = (e: any) => {
    if (e.target.dataset.name === 'trigger' || !modalRef?.current?.classList?.contains('on')) return;
    if (!modalRef || (!modalRef?.current?.contains(e.target) as boolean)) return setModalState(false);
  };

  useEffect(() => {
    window.addEventListener('click', handlerClickEl);

    return () => {
      window.removeEventListener('click', handlerClickEl);
    };
  }, [modalRef]);

  return (
    <div ref={modalRef} className={`modal ${isVisible ? 'on' : ''}`}>
      <dl className="call-path">
        <dt>알파(alpha) 호출경로</dt>
        <dd>https://alpha-{currPart}-api.nhn-commerce.com</dd>
        <dt>리얼(real) 호출경로</dt>
        <dd>https://{currPart}-api.nhn-commerce.com</dd>
      </dl>
      {currPart !== 'server' ? <p className="call-path-out-link">(모듈) - web, backoffice, internal, admin</p> : ''}
      <button className="modal__close" onClick={() => setModalState(false)}>
        <span>닫기</span>
      </button>
    </div>
  );
}

export default Modal;
